import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../AppShell/styles";

export const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  /* The main action (last, on the right) takes half the bar, as in the sections list */
  > :last-child:not(:first-child) {
    flex: 0 0 50%;
  }
`;

/** The fixed bar's layer: a list opening over it (e.g. the fonts') goes above this. */
export const SAVE_BAR_Z_INDEX = 50;

export const Box = styled.div<{ $sticky?: boolean }>`
  padding: 1.5rem 0rem;
  margin: 0rem 2rem;

  ${props =>
    props.$sticky &&
    css`
      position: sticky;
      bottom: var(--app-bottom-bar-offset, 0px);
      z-index: ${SAVE_BAR_Z_INDEX};
      padding: 1rem 2rem;
      margin: 0;
      background: var(--color-neutral-darkness);

      /* The top line stops where the content does (the side padding), instead of running edge to edge */
      &::before {
        position: absolute;
        top: 0;
        right: 2rem;
        left: 2rem;
        height: 1px;
        content: "";
        background: var(--color-neutral-dark);
      }

      @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
        padding: 1rem 20px;

        &::before {
          right: 20px;
          left: 20px;
        }
      }
    `}
`;

/* Page wrapper for a sticky SaveBar: at least one screen tall, so the bar sits at the bottom even
   when the content is short */
export const StickyBarPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh - var(--app-bottom-nav-height, 0px));
`;

/* Space between the last block and the sticky bar; its auto top margin pushes the bar to the bottom
   of short pages inside a StickyBarPage */
export const StickySpacer = styled.div`
  flex-shrink: 0;
  height: 2rem;
  margin-top: auto;
`;
